// src/services/recipeService.js
import apiClient from './apiClient';

export async function fetchAllRecipes() {
  return apiClient.get('api/recipes/');
}
 